import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	warningMessage: {
		id: 'polaris-common.field-info-marker.issue-linking-disabled.warning-message',
		defaultMessage: 'Warning',
		description: 'Warning message shown to the customer when issue linking is disabled',
	},
});
